import { create } from 'zustand'

const useFramingPreviewImageStore = create((set, get) => ({
  previewImages: {},
  generation: 0,
  loadPreviewImage: (src) => {
    if (!src) return

    const existing = get().previewImages[src]
    if (existing?.status === 'loading' || existing?.status === 'ready') return
    const generation = get().generation

    set((state) => ({
      previewImages: {
        ...state.previewImages,
        [src]: { src, status: 'loading' },
      },
    }))

    const request = new Image()
    const clearHandlers = () => {
      request.onload = null
      request.onerror = null
    }
    request.onload = () => {
      if (get().generation !== generation) {
        clearHandlers()
        return
      }
      set((state) => ({
        previewImages: {
          ...state.previewImages,
          [src]: {
            src,
            status: request.naturalWidth > 0 && request.naturalHeight > 0 ? 'ready' : 'error',
            width: request.naturalWidth,
            height: request.naturalHeight,
          },
        },
      }))
      clearHandlers()
    }
    request.onerror = () => {
      if (get().generation !== generation) {
        clearHandlers()
        return
      }
      set((state) => ({
        previewImages: {
          ...state.previewImages,
          [src]: { src, status: 'error' },
        },
      }))
      clearHandlers()
    }
    request.src = src
  },
  resetPreviewImages: () =>
    set((state) => ({ previewImages: {}, generation: state.generation + 1 })),
}))

export default useFramingPreviewImageStore
